/* Switch view mode
==================================== */
function setViewMode(mode){
	$('.trigger[data-view="'+mode+'"]').addClass('active').siblings().removeClass('active');
	body.attr('data-view', mode);
	sessionStorage.setItem('he-view', mode);
}
if($('[data-view]').length){
	if(sessionStorage.getItem('he-view') === 'txt'){
		setViewMode('txt');
	}
	$('.trigger[data-view]').click(function(){
		$(window).scrollTop(0);
		setViewMode($(this).data('view'));
	});
}

/* Universe
==================================== */
if(body.data('layout') == 'blog' && $('.module-list_thumbnail').length){
	$('.module-list_thumbnail').each(function(){
		let t = $(this);
		if(t.hasClass('horizontal')){
			if(t.hasClass('big')){
				t.css({
					'--row': 1 + Math.floor(Math.random()*8),
					'--col': 1 + Math.floor(Math.random()*7)
				})
			}else{
				t.css({
					'--row': 1 + Math.floor(Math.random()*9),
					'--col': 1 + Math.floor(Math.random()*8)
				})
			}
			t.css({
				'--row_mobile': 1 + Math.floor(Math.random()*5),
				'--col_mobile': 1 + Math.floor(Math.random()*2)
			})
		}else{
			if(t.hasClass('big')){
				t.css({
					'--row': 1 + Math.floor(Math.random()*5),
					'--col': 1 + Math.floor(Math.random()*8)
				})
			}else{
				t.css({
					'--row': 1 + Math.floor(Math.random()*7),
					'--col': 1 + Math.floor(Math.random()*9)
				})
			}
			t.css({
				'--row_mobile': 1 + Math.floor(Math.random()*4),
				'--col_mobile': 1 + Math.floor(Math.random()*3)
			})
		}
	})
}